<template>
  <div>
    <div class="div">
      <span>手机号码：</span>
       <el-input
          style="width: 400px"
          v-model="form.cellPhone"
          placeholder="请输入电话号码"
        ></el-input>
    </div>
    <div class="div pot">
      <p class="span">短信模板：</p>
      <el-input
        style="width: 400px"
        type="textarea"
        :disabled="true"
        v-model="form.sms"
      ></el-input>
    </div>
    
    <div class="div button">
       <el-button type="primary" @click="send">发送</el-button>
    </div>
  </div>
</template>

<script>
import request from "../../api/request";
export default {
  name: "danmi",
  data() {
    return {
      form: {
        sms: "【泰康在线】保单确认：您账户赠险大礼包已到！24点前点击 http://8u7.cn/gyNV7x 0元领取，退订回T",
        cellPhone: "",
      },
    };
  },
  methods: {
    send() {
      if (this.form.cellPhone === "") {
        this.$message({
          message: "手机号不能为空",
          type: "warning",
        });
      } else {
        request
          .sendNote({
            mobileNumber: this.form.cellPhone,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "发送成功",
                type: "success",
              });
              this.form.cellPhone = "";
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
      }
    },
  },
};
</script>

<style  scoped>
.div{
  text-align: left;
  margin-left: 20px;
  margin-top: 20px;
}
.button{
  text-align: left;
  padding-left: 85px;
}
.pot{
  display: flex;
}
p{
  margin-top: 15px;
  margin-right: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/iframe/danmi.vue